export const dnsRegex = /^(?=.+$)(([a-zA-Z0-9]+|\*)([-.](([a-zA-Z0-9]+)|\*))*)$/;